import React, { Component } from 'react';
import { Router, Route, Switch, withRouter } from 'react-router';
import withRole from 'components/Security/withRole';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import { ROLE_SHOW_REPORT_ARCHIVE } from 'helpers/roles';

import List from './List';

class MealTypes extends Component {
  render() {
    const { props } = this;

    const ListSecured = withRole(ROLE_SHOW_REPORT_ARCHIVE, List);

    return (
      <DataGridStateContextProvider>
        <Router history={this.props.history}>
          <Switch>
            <Route
              exact={true}
              path={`${this.props.match.url}/`}
              render={parentProps => <ListSecured {...props} {...parentProps} />}
            />
          </Switch>
        </Router>
      </DataGridStateContextProvider>
    );
  }
}

export default withRouter(MealTypes);
